import React, { useState } from 'react'
import axios from 'axios';
import * as CONSTANTS from "../../../CONSTANTS";
import './mini-dashboard.css';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';

function DashboardOnvite3({user, selectedEvent, setUpdateAction}) {

  const [processing, setProcessing]                   = useState(false);
  const [editMode, setEditMode]                       = useState(false);

  const initialState = {
    mainEventTitle: selectedEvent.onviteDetails.mainEventTitle || '',
    mainEventDate: selectedEvent.onviteDetails.mainEventDate || '',
    mainAddress: selectedEvent.onviteDetails.mainAddress || '',
    mainStart: selectedEvent.onviteDetails.mainStart || '',
    mainEnd: selectedEvent.onviteDetails.mainEnd || '',
    receptionDate: selectedEvent.onviteDetails.receptionDate || '',
    receptionAddress: selectedEvent.onviteDetails.receptionAddress || '',
    receptionStart: selectedEvent.onviteDetails.receptionStart || '',
    receptionEnd: selectedEvent.onviteDetails.receptionEnd || '',
  };

  const [formData, setFormData] = useState(initialState);
  const [changedFields, setChangedFields] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setChangedFields(prev => ({ ...prev, [name]: value }));
  };

  const handleEditToggle = () => {
    setEditMode(!editMode);
    if (!editMode) setChangedFields({});
  };

  const handleSubmit = async () => {
    try {

      setProcessing(true);
       const payload = {
          onviteDetails: {
            ...changedFields
          },
          eventId: selectedEvent._id
        };
      
      const result = await axios.put(`${CONSTANTS.API_URL}annivites/onvite/update-onvite/details/v1`, payload, {
          headers: {
                token: 'Bearer ' + user.accessToken,
              },
        });

        console.log(result);

      setProcessing(false);
      setUpdateAction(prev => prev + 1);
      toast.success(result.data.message);
      setEditMode(false);
      
    } catch (err) {
      setProcessing(false);
      console.error(err);
      toast.error("Failed to update");
    }
  };

  return (
    <div className="dashboard-inner-box">
       <div className="header-bar">
        <h5>Onvite Locations</h5>
        <button className="btn btn-sm btn-main" onClick={handleEditToggle}>
          {editMode ? "Cancel" : "Edit"}
        </button>
      </div>

      <div className="info-fields-grid">
        <Field label="Main Event Title" name="mainEventTitle" value={formData.mainEventTitle} editable={editMode} onChange={handleChange} />
        <Field label="Main Event Date" name="mainEventDate" value={formData.mainEventDate} editable={editMode} onChange={handleChange} type="date" />
        <Field label="Main Address" name="mainAddress" value={formData.mainAddress} editable={editMode} onChange={handleChange} />
        <Field label="Main Start Time" name="mainStart" value={formData.mainStart} editable={editMode} onChange={handleChange} type="time" />
        <Field label="Main End Time" name="mainEnd" value={formData.mainEnd} editable={editMode} onChange={handleChange} type="time" />
        <Field label="Reception Date" name="receptionDate" value={formData.receptionDate} editable={editMode} onChange={handleChange} type="date" />
        <Field label="Reception Address" name="receptionAddress" value={formData.receptionAddress} editable={editMode} onChange={handleChange} />
        <Field label="Reception Start Time" name="receptionStart" value={formData.receptionStart} editable={editMode} onChange={handleChange} type="time" />
        <Field label="Reception End Time" name="receptionEnd" value={formData.receptionEnd} editable={editMode} onChange={handleChange} type="time" />
      </div>

      <p className="mt-3">
        <Link to={'/couple-event/' + selectedEvent._id}>View onsite</Link>
      </p>
      {editMode && (
        <div className="form-actions">
          <button className="btn btn-main" onClick={handleSubmit} disabled={processing}>
            {
              processing ? "Processing" : "Save Changes"
            }
          </button>
        </div>
      )}
    </div>
  )
}

function Field({ label, name, value, editable, onChange , type = "text" }) {
  return (
    <div className="field-item">
      <label>{label}</label>
      {editable ? (
        <input
          type={type}
          className="form-control"
          name={name}
          value={value}
          onChange={onChange}
        />
      ) : (
        <div className="text-display">{value || '—'}</div>
      )}
    </div>
  );
}


export default DashboardOnvite3